import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilterChipComponent {
  @Input() public title: string = '';
  @Input() public isShowGroup: boolean = false;
  @Input() public isMobile: boolean = false;

  @Output() public removeClicked = new EventEmitter<any>();
  @Output() public showGroupClicked = new EventEmitter<any>();
}
